'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box from '../../../box'
import LinearGradient from '../../../linear-gradient'

/* -----------------------------------------------------------------------------
 * RadioButtonField
 * -------------------------------------------------------------------------- */

export type RadioButtonFieldProps = {
  isChecked: boolean
  size?: number
}

const RadioButtonWrapper = ({ isChecked, size }: RadioButtonFieldProps) => {
  const Component = isChecked ? LinearGradient : Box

  return (
    <Component
      borderRadius='pill'
      borderWidth={isChecked ? 0 : 1}
      borderColor='shade05'
      height={size}
      width={size}
    />
  )
}

export default RadioButtonWrapper
